export default __webpack_public_path__ + "static/media/instagram.cd1e531f.svg";